export class GoalNotSucceededError extends Error {
  public constructor(message: string) {
    super(message);
  }
}
